import { FC } from 'react';
import { CalendarIcon, cn } from '@fe-learner-common';
import {
  PhysicalEvent,
  TeleconferenceEvent,
  VirtualEvent,
} from './EventTypeGuards';
import { EventTags, TTag } from './Tags';
import { EventTexts } from './Event';
import { formatDateTimeRange } from '@fe-learner-common/utils/date';

type EventRowDetailsProps = {
  className?: string;
  texts: EventTexts;
  eventType: string;
  disabled: boolean;
  title: string;
  starts?: number | null;
  ends?: number | null;
  location?: string | null;
  pastEvent: boolean;
};
const Divider = () => (
  <span aria-hidden={true} className="lf:text-body-md lf:max-md:hidden">
    ·
  </span>
);

const EventRowDetails: FC<EventRowDetailsProps> = ({
  className,
  texts,
  eventType,
  disabled,
  title,
  starts,
  ends,
  location,
  pastEvent,
}) => {
  return (
    <div className={cn('lf:flex lf:gap-x-4', className)}>
      {starts ? (
        <CalendarIcon
          className="lf:md:self-center"
          aria-hidden
          disabled={disabled}
          date={starts}
          size="md"
        />
      ) : null}
      <div className="lf:flex lf:flex-col lf:items-start lf:gap-1">
        <h4 className="lf:text-label-lg">{title}</h4>
        <div className="lf:flex lf:flex-col lf:flex-wrap lf:items-start lf:gap-2 lf:text-left lf:md:flex-row lf:md:items-center ">
          {starts ? (
            <>
              <span className="lf:sr-only">{texts.eventDate}</span>
              <span className="lf:text-body-md lf:capitalize lf:text-neutral-500">
                {formatDateTimeRange(starts, ends)}
              </span>
            </>
          ) : null}
          <PhysicalEvent eventType={eventType} condition={!!location}>
            <>
              <Divider />
              <span className="lf:text-body-md lf:text-neutral-500">{location}</span>
            </>
          </PhysicalEvent>
          <VirtualEvent eventType={eventType}>
            <>
              <Divider />
              <span className="lf:text-body-md lf:text-neutral-500">
                {texts.virtualEvent}
              </span>
            </>
          </VirtualEvent>
          <TeleconferenceEvent eventType={eventType}>
            <>
              <Divider />
              <span className="lf:text-body-md lf:text-neutral-500">
                {texts.phoneConferenceEvent}
              </span>
            </>
          </TeleconferenceEvent>
          {pastEvent && (
            <>
              <Divider />
              <EventTags
                tags={[{ pastEvent: '' }] as TTag[]}
                texts={texts.tags}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventRowDetails;
